'use strict';

import ngResource from 'angular-resource';

class MailTestService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/mail_test', {},
            { create: { method: 'POST', isArray: false} }
        );

        this.oem_api = $resource(
            '/api/oem/mail_test', {},
            { create: { method: 'POST', isArray: false} }
        );
    }
}

export default angular.module('leptonApp.MailTestService', ['ngResource'])
    .service('MailTestService', ['$resource', MailTestService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/mail_test/mail_test.service.js